import { DISSOC_SHARE_URL } from 'root/src/client/logic/static/actionIds'

export default () => ({
	type: DISSOC_SHARE_URL,
})
